export const APP_MODES = ['standard', 'd2c'] as const satisfies readonly AppMode[];

export const DEFAULT_APP_MODE: AppMode = 'standard';

export function isAppMode(value: unknown): value is AppMode {
  return APP_MODES.includes(value as AppMode);
}
